import React from 'react';
import { Box, Typography, Button } from '@mui/material';

const CallToAction: React.FC = () => {

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        color: 'common.white',
        padding: 4,
        textAlign: 'center',
      }}
    >
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2 }}>
        Ready to Experience the Best Laundry Service?
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        Try us today and enjoy clean clothes effortlessly.
      </Typography>
      <Button 
        variant="contained" 
        size="large" 
        color="primary"
        onClick={() => window.open('https://www.mylaundryorder.com/?s=1740758514200x273776307348996480', '_blank', 'width=600,height=800')}
        >
        SCHEDULE NOW
      </Button>
    </Box>
  );
};

export default CallToAction;
